/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import i18n from 'live/services/i18n'

import {
    IEngineeringAuditBarrierReport,
    IEngineeringAuditConsequenceReport,
    IEngineeringAuditThreatReport,
    ISelectBowtie
} from 'plugin-codaf-risk-ext-bowtie/types/engineeringAudit'
import { Entity } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import {
    EngineeringAuditBarrierReport,
    ReportPagination,
    EngineeringAuditEscalationFactorReport,
    EngineeringAuditControlBarrierReport,
    EngineeringAuditTopEventReport,
    EngineeringAuditConsequenceReport,
    EngineeringAuditThreatReport
} from './components'
import { ViewContainer } from './styles'

interface IProps {
    preset: string
    info?: IEngineeringAuditBarrierReport | IEngineeringAuditThreatReport | IEngineeringAuditConsequenceReport | null
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    filterByResource: string
    filterByBowtie: ISelectBowtie
}

interface ISelectLimit {
    value: number
    label: string
}

export const View: React.FC<IProps> = ({
    preset,
    startDay,
    startHour,
    endDay,
    endHour,
    filterByBowtie,
    filterByResource
}) => {
    const [limit, setLimit] = useState<ISelectLimit>({ value: 30, label: `30 items | ${i18n('page')}` })
    const [offset, setOffset] = useState(0)
    const [itemsLength, setItemsLength] = useState<number>()
    const [page, setPage] = useState<number>(1)
    const [searchString, setSearchString] = useState<string>('')

    useEffect(() => {
        setOffset(0)
    }, [preset, startDay, startHour, endDay, endHour])

    switch (preset) {
        case Entity.BARRIER:
            return (
                <ViewContainer>
                    <div className="titleBar">
                        <span>{filterByBowtie?.label}</span>
                    </div>
                    <div className="pagination">
                        <ReportPagination
                            total={itemsLength}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            searchString={searchString}
                            setSearchString={setSearchString}
                            preset={preset}
                        />
                    </div>
                    <EngineeringAuditBarrierReport
                        setItemsLength={setItemsLength}
                        numberOfItems={limit.value}
                        startDay={startDay}
                        endDay={endDay}
                        startHour={startHour}
                        endHour={endHour}
                        page={page}
                        setPage={setPage}
                        filterByResource={filterByResource}
                        filterByBowtie={filterByBowtie}
                        limit={limit.value}
                        searchString={searchString}
                    />
                </ViewContainer>
            )
            break
        case Entity.ESCALATION_FACTOR:
            return (
                <ViewContainer>
                    <div className="titleBar">
                        <span>{filterByBowtie?.label}</span>
                    </div>
                    <div className="pagination">
                        <ReportPagination
                            total={itemsLength}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            searchString={searchString}
                            setSearchString={setSearchString}
                            preset={preset}
                        />
                    </div>

                    <EngineeringAuditEscalationFactorReport
                        setItemsLength={setItemsLength}
                        numberOfItems={limit.value}
                        startDay={startDay}
                        endDay={endDay}
                        startHour={startHour}
                        endHour={endHour}
                        page={page}
                        setPage={setPage}
                        filterByResource={filterByResource}
                        filterByBowtie={filterByBowtie}
                        limit={limit.value}
                        searchString={searchString}
                    />
                </ViewContainer>
            )
            break
        case Entity.CONTROL_BARRIER:
            return (
                <ViewContainer>
                    <div className="titleBar">
                        <span>{filterByBowtie?.label}</span>
                    </div>
                    <div className="pagination">
                        <ReportPagination
                            total={itemsLength}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            searchString={searchString}
                            setSearchString={setSearchString}
                            preset={preset}
                        />
                    </div>

                    <EngineeringAuditControlBarrierReport
                        setItemsLength={setItemsLength}
                        totalItems={itemsLength}
                        numberOfItems={limit.value}
                        startDay={startDay}
                        endDay={endDay}
                        startHour={startHour}
                        endHour={endHour}
                        page={page}
                        setPage={setPage}
                        filterByResource={filterByResource}
                        filterByBowtie={filterByBowtie}
                        limit={limit.value}
                        searchString={searchString}
                    />
                </ViewContainer>
            )
            break
        case Entity.TOP_EVENT:
            return (
                <ViewContainer>
                    <div className="titleBar">
                        <span>{filterByBowtie?.label}</span>
                    </div>
                    <div className="pagination">
                        <ReportPagination
                            total={itemsLength}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            searchString={searchString}
                            setSearchString={setSearchString}
                            preset={preset}
                        />
                    </div>

                    <EngineeringAuditTopEventReport
                        setItemsLength={setItemsLength}
                        numberOfItems={limit.value}
                        startDay={startDay}
                        endDay={endDay}
                        startHour={startHour}
                        endHour={endHour}
                        page={page}
                        setPage={setPage}
                        filterByResource={filterByResource}
                        filterByBowtie={filterByBowtie}
                        limit={limit.value}
                        searchString={searchString}
                    />
                </ViewContainer>
            )
            break
        case Entity.THREAT:
            return (
                <ViewContainer>
                    <div className="titleBar">
                        <span>{filterByBowtie?.label}</span>
                    </div>
                    <div className="pagination">
                        <ReportPagination
                            total={itemsLength}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            searchString={searchString}
                            setSearchString={setSearchString}
                            preset={preset}
                        />
                    </div>

                    <EngineeringAuditThreatReport
                        setItemsLength={setItemsLength}
                        numberOfItems={limit.value}
                        startDay={startDay}
                        endDay={endDay}
                        startHour={startHour}
                        endHour={endHour}
                        page={page}
                        setPage={setPage}
                        filterByResource={filterByResource}
                        filterByBowtie={filterByBowtie}
                        limit={limit.value}
                        searchString={searchString}
                    />
                </ViewContainer>
            )
            break
        case Entity.CONSEQUENCE:
            return (
                <ViewContainer>
                    <div className="titleBar">
                        <span>{filterByBowtie?.label}</span>
                    </div>
                    <div className="pagination">
                        <ReportPagination
                            total={itemsLength}
                            offset={offset}
                            setOffset={setOffset}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            searchString={searchString}
                            setSearchString={setSearchString}
                            preset={preset}
                        />
                    </div>

                    <EngineeringAuditConsequenceReport
                        setItemsLength={setItemsLength}
                        numberOfItems={limit.value}
                        startDay={startDay}
                        endDay={endDay}
                        startHour={startHour}
                        endHour={endHour}
                        page={page}
                        setPage={setPage}
                        filterByResource={filterByResource}
                        filterByBowtie={filterByBowtie}
                        limit={limit.value}
                        searchString={searchString}
                    />
                </ViewContainer>
            )
            break
        default:
            return (
                <ViewContainer>
                    <span>{i18n('Select the context to view an audit report')}</span>
                </ViewContainer>
            )
    }
}
